import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { lyfshortLogin, lyfshortLoginFailed, lyfshortLoginSuccess, logout } from "../auth/authSlice";

interface AccessTokenState {
  body: string | null;
  authId: string | null;
}

const initialState: AccessTokenState = {
  body: null,
  authId: null,
}

const accessTokenSlice = createSlice({
  name: 'accessToken',
  initialState,
  reducers: {
    fetchAccessToken: (state, action) => {},
    fetchAccessTokenSuccess: (state, action) => {
      if (state.authId === action.payload.authId) {
        state.body = action.payload.tokens.accessToken
      }
    },
    fetchAccessTokenFailed: (state, action) => {
      state.body = null
      state.authId = null
    }
  },
  extraReducers(builder) {
    builder
      .addCase(lyfshortLogin, (state, action) => {
        state.authId = action.payload?.authData?.authId
        state.body = action.payload?.authData?.tokens?.accessToken
      })
      .addCase(lyfshortLoginSuccess, (state, action) => {
        state.authId = action.payload.user.authId
        state.body = action.payload.tokens.accessToken
      })
      .addCase(lyfshortLoginFailed, (state, action) => {
        state.authId = null
        state.body = null
      })
      .addCase(logout, (state, action) => {
        state.authId = null
        state.body = null
      })
  },
})

export const { fetchAccessToken, fetchAccessTokenSuccess, fetchAccessTokenFailed } = accessTokenSlice.actions;
export const selectAccessToken = (state: RootState) => state.accessToken
export default accessTokenSlice.reducer;